import React from 'react';

const Prism = (props) => (
    <svg
        width="16px"
        height="17px"
        viewBox="0 0 16 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/prism w Copy@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-391.000000, -1971.000000)" fill="#000000">
                <g id="Icon/prism-w-Copy" transform="translate(391.000000, 1971.000000)">
                    <path
                        d="M10.1805643,15.7619065 C9.91099773,16.0764009 9.94741889,16.5498758 10.2619133,16.8194425 C10.5522158,17.0682732 10.977981,17.0563806 11.2537871,16.8057202 L11.3194493,16.7380935 L15.8194493,11.4880935 C16.0401307,11.2306318 16.0585208,10.8609215 15.8746196,10.5847517 L15.8194493,10.5119065 L11.3194493,5.26190647 C11.0498826,4.94741209 10.5764077,4.91099094 10.2619133,5.18055755 C9.97161076,5.42938827 9.91824639,5.8519634 10.1237757,6.16286094 L10.1805643,6.23809353 L14.2615068,11 L10.1805643,15.7619065 Z"
                        id="🎨-Color"
                    ></path>
                    <path
                        d="M0.180564347,10.7619065 C-0.0890022662,11.0764009 -0.0525811134,11.5498758 0.261913269,11.8194425 C0.552215775,12.0682732 0.977981045,12.0563806 1.25378707,11.8057202 L1.31944925,11.7380935 L5.81944925,6.48809353 C6.0401307,6.23063184 6.05852082,5.8609215 5.87461961,5.58475171 L5.81944925,5.51190647 L1.31944925,0.26190647 C1.04988264,-0.0525879121 0.576407651,-0.0890090649 0.261913269,0.180557548 C-0.0283892378,0.429388268 -0.0817536082,0.851963401 0.123775697,1.16286094 L0.180564347,1.23809353 L4.2615068,6 L0.180564347,10.7619065 Z"
                        id="🎨-Color"
                        transform="translate(3.000000, 6.000000) scale(-1, 1) translate(-3.000000, -6.000000) "
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default Prism;
